var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 67,
    viewBox: "0 0 62 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1127_144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9418 5.42427L31 1.5957M31 1.5957L35.0582 5.42427M31 1.5957V10.3163M10.2582 15.2084V9.67824M10.2582 9.67824H16.12M10.2582 9.67824L17.0218 15.8465M5.97455 33.0751L1.69092 29.2465M1.69092 29.2465L5.97455 25.2052M1.69092 29.2465H11.16M45.88 9.67824H51.7418M51.7418 9.67824V15.2084M51.7418 9.67824L44.9782 15.8465M56.0255 25.2052L60.3091 29.2465M60.3091 29.2465L56.0255 33.0751M60.3091 29.2465H50.84M45.88 65.4052H16.12C14.3164 65.4052 12.7382 63.9163 12.7382 62.2148V61.1513C12.7382 53.7068 19.0509 47.7513 26.9418 47.7513H35.0582C42.9491 47.7513 49.2618 53.7068 49.2618 61.1513V62.2148C49.2618 63.9163 47.6836 65.4052 45.88 65.4052ZM31 17.5481C25.3636 17.5481 20.8546 21.8021 20.8546 27.1195C20.8546 32.437 25.3636 40.5195 31 40.5195C36.6364 40.5195 41.1455 32.437 41.1455 27.1195C41.1455 21.8021 36.6364 17.5481 31 17.5481Z",
    stroke: "#E6882B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1127_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.a76a19db26447fd2a7d8bbc566c74998.svg";
export { ForwardRef as ReactComponent };